/**
 * School public-website API — uses VITE_WEBSITE_API_URL
 * Schema: school_website_live.sql (tm_school_master, tm_banners, …)
 * Created By Cursor
 */
import BaseApiService from "./BaseApiService";
import environment from "../config/environment";

class WebsiteApiService extends BaseApiService {
  constructor() {
    super(environment.WEBSITE_API_URL, environment.API_TIMEOUT);
  }

  // Created By Cursor
  async getWebsiteDashboard() {
    try {
      const response = await this.makeRequest("getWebsiteDashboard.php");
      return this.handleResponse(
        response,
        "Website dashboard loaded",
        "Failed to load website dashboard"
      );
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Created By Cursor
  async getWebsiteSchools({ q = "", status = "all", limit = 200, offset = 0 } = {}) {
    try {
      const params = new URLSearchParams({
        q: String(q || ""),
        status: String(status || "all"),
        limit: String(limit),
        offset: String(offset),
      });
      const response = await this.makeRequest(`getWebsiteSchools.php?${params.toString()}`);
      if (response.api_status === "OK") {
        return {
          success: true,
          data: Array.isArray(response.data) ? response.data : [],
          total: Number(response.total) || 0,
          message: "Website schools loaded",
        };
      }
      return {
        success: false,
        error: response.api_remark || "Failed to load website schools",
        data: [],
        total: 0,
      };
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Created By Cursor
  async getWebsiteSchoolDetail(schoolCode) {
    try {
      const params = new URLSearchParams({ school_code: String(schoolCode || "") });
      const response = await this.makeRequest(
        `getWebsiteSchoolDetail.php?${params.toString()}`
      );
      return this.handleResponse(
        response,
        "School website detail loaded",
        "Failed to load school website detail"
      );
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Created By Cursor
  async getWebsiteModule(schoolCode, module) {
    try {
      const params = new URLSearchParams({
        school_code: String(schoolCode || ""),
        module: String(module || ""),
      });
      const response = await this.makeRequest(`getWebsiteModule.php?${params.toString()}`);
      return this.handleResponse(
        response,
        "Website module loaded",
        "Failed to load website module"
      );
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Created By Cursor
  async updateWebsiteSchoolDetails(payload = {}) {
    try {
      const params = this.createSearchParams(payload);
      const response = await this.makeRequest(
        `updateWebsiteSchoolDetails.php?${params.toString()}`
      );
      return this.handleResponse(
        response,
        "School website details updated",
        "Failed to update school website details"
      );
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Created By Cursor
  async createWebsiteSchool(payload = {}) {
    try {
      const params = this.createSearchParams(payload);
      const response = await this.makeRequest(
        `createWebsiteSchool.php?${params.toString()}`
      );
      return this.handleResponse(
        response,
        "School website created",
        "Failed to create school website"
      );
    } catch (error) {
      return this.handleError(error);
    }
  }
}

const websiteApiService = new WebsiteApiService();
export default websiteApiService;
